import { useFormik } from 'formik';
import { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { Loader } from 'react-clip-loader';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { doimatKhau } from '../../services/nguoidung';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import { useDispatch } from 'react-redux';

const DoiMatKhau = () => {
    const dispatch = useDispatch();

    const { handleChange, values, handleSubmit, touched, errors, setErrors, setTouched } = useFormik({
        initialValues: {
            matKhauCu: "",
            matKhauMoi: "",
            xacNhanMatKhau: ""
        },
        validationSchema: Yup.object({
            matKhauCu: Yup.string().required('Bắt buộc').min(6, 'Mật khẩu ít nhất 6 ký tự'),
            matKhauMoi: Yup.string().required('Bắt buộc').min(6, 'Mật khẩu ít nhất 6 ký tự')
                .matches(
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,})/,
                    "Mật khẩu phải có ít nhất một ký tự viết hoa, viết thường, chữ số và ký tự đặc biệt."
                ),
            xacNhanMatKhau: Yup.string().required('Bắt buộc').min(6, 'Mật khẩu ít nhất 6 ký tự')
                .matches(
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,})/,
                    "Mật khẩu phải có ít nhất một ký tự viết hoa, viết thường, chữ số và ký tự đặc biệt."
                ).oneOf([Yup.ref("matKhauMoi")], "Mật khẩu không khớp")
        }),
        onSubmit: (values) => {
            submitLuu(values);
        }
    });
    const submitLuu = async (data:any) => {
        try {
            dispatch(showLoadingScreen());
            await doimatKhau(data);
            setErrors({});
            setTouched({});
            toast.success("Đổi mật khẩu thành công!");
            dispatch(hideLoadingScreen());
        }
        catch (error: any) {
            dispatch(hideLoadingScreen());
            setErrors({});
            setTouched({});
            toast.error(error.message || "Vui lòng thử lại");
        };
    }

    return (
        <div className="card-body">
            <div className="tab-content">
                <form className="form-horizontal" onSubmit={handleSubmit}>
                    <div className="form-group row">
                        <label className="col-sm-2  offset-md-2 control-label">Mật khẩu cũ:<span className="text-red"> * </span></label>
                        <div className="col-sm-4">
                            <Form.Control
                                id="matKhauCu"
                                name="matKhauCu"
                                type="password"
                                placeholder="Mật khẩu cũ"
                                onChange={handleChange}
                                value={values.matKhauCu}
                                isValid={touched.matKhauCu && !errors.matKhauCu}
                                isInvalid={touched.matKhauCu && !!errors.matKhauCu}
                            />
                            {touched.matKhauCu && errors.matKhauCu ? (
                                <Form.Control.Feedback type="invalid">
                                    {errors.matKhauCu}
                                </Form.Control.Feedback>
                            ) : null}
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2  offset-md-2 control-label">Mật khẩu mới:<span className="text-red"> * </span></label>
                        <div className="col-sm-4">
                            <Form.Control
                                id="matKhauMoi"
                                name="matKhauMoi"
                                type="password"
                                placeholder="Mật khẩu mới"
                                onChange={handleChange}
                                value={values.matKhauMoi}
                                isValid={touched.matKhauMoi && !errors.matKhauMoi}
                                isInvalid={touched.matKhauMoi && !!errors.matKhauMoi}
                            />
                            {touched.matKhauMoi && errors.matKhauMoi ? (
                                <Form.Control.Feedback type="invalid">
                                    {errors.matKhauMoi}
                                </Form.Control.Feedback>
                            ) : null}
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2  offset-md-2 control-label">Xác nhận mật khẩu:<span className="text-red"> * </span></label>
                        <div className="col-sm-4">
                            <Form.Control
                                id="xacNhanMatKhau"
                                name="xacNhanMatKhau"
                                type="password"
                                placeholder="Xác nhận mật khẩu mới"
                                onChange={handleChange}
                                value={values.xacNhanMatKhau}
                                isValid={touched.xacNhanMatKhau && !errors.xacNhanMatKhau}
                                isInvalid={touched.xacNhanMatKhau && !!errors.xacNhanMatKhau}
                            />
                            {touched.xacNhanMatKhau && errors.xacNhanMatKhau ? (
                                <Form.Control.Feedback type="invalid">
                                    {errors.xacNhanMatKhau}
                                </Form.Control.Feedback>
                            ) : null}
                        </div>
                    </div>
                    <div className="form-group row text-center">
                        <div className="col-sm-12 text-center">
                            <Button className="btn btn-sm btn-primary" type="submit">
                            <i className="fa fas fa-key ml-2" aria-hidden="true" />   Đổi mật khẩu
                            </Button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default DoiMatKhau;
